import { HttpAgent, Actor } from '@dfinity/agent';
import { Principal } from '@dfinity/principal';
import { idlFactory as civic } from './civic_canister_backend.did';
import { CIVIC_CANISTER_BACKEND_ID } from '../config';
const getCredentialsFromCanister = async (principal) => {
    const agent = new HttpAgent({ host: 'https://ic0.app' });
    agent.fetchRootKey();
    const actor = Actor.createActor(civic, {
        agent,
        canisterId: CIVIC_CANISTER_BACKEND_ID,
    });
    try {
        const vc = await actor.get_all_credentials(Principal.fromText(principal));
        return vc;
    }
    catch (error) {
        return Error(error);
    }
};
// Check for the existence of a credential for the user on the Civic canister
export const getToken = async (principal, gatekeeperNetwork, issuer) => {
    const credentials = await getCredentialsFromCanister(principal);
    // Check if returned Result is an Error, otherwise it is an array of credentials
    if (credentials.Err) {
        return undefined;
    }
    const civicCredentials = credentials.Ok ? credentials.Ok : [];
    if (civicCredentials.length === 0) {
        return undefined;
    }
    const isCivicCredential = (cred) => cred.issuer === issuer;
    const getClaim = (claims, key) => {
        const claim = claims.find(([claimKey]) => claimKey === key);
        return claim ? claim[1].Text : undefined;
    };
    const passCredential = civicCredentials.filter(isCivicCredential).find((cred) => {
        const { claims } = cred.claim[0];
        const passType = getClaim(claims, 'passType');
        return passType === gatekeeperNetwork;
    });
    if (!passCredential) {
        return undefined;
    }
    const { claims } = passCredential.claim[0];
    const expirationDate = getClaim(claims, 'expirationDate');
    const status = getClaim(claims, 'status');
    if (!expirationDate || !status) {
        return undefined;
    }
    // Map the credential to the GatewayToken
    return {
        identifier: passCredential.id,
        expiryTime: new Date(expirationDate).getTime(),
        state: status,
        owner: principal,
        gatekeeperNetworkAddress: gatekeeperNetwork,
        issuingGatekeeper: issuer,
    };
};
